// ビューポートの内側の高さを取得
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

// SPハンバーガーメニュー
document.querySelectorAll(".navkey").forEach(navkey => {
  navkey.addEventListener("click", () => {
    const hidecnt = navkey.closest(".hidecnt");
    if (hidecnt.classList.contains("active")) {
      hidecnt.classList.remove("active");
    } else {
      document.querySelectorAll(".hidecnt").forEach(el => el.classList.remove("active"));
      hidecnt.classList.add("active");
    }
  });
});

document.querySelectorAll(".-nav_close").forEach(navClose => {
  navClose.addEventListener("click", () => {
    navClose.closest(".hidecnt").classList.remove("active");
  });
});

// スムーズスクロール
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", (event) => {
    event.preventDefault();
    const href = anchor.getAttribute("href");
    const target = document.querySelector(href === "#" || href === "" ? "html" : href);
    const headerHeight = window.matchMedia("(max-width: 768px)").matches ? 130 : 280;
    const position = target.offsetTop - headerHeight;

    window.scrollTo({
      top: position,
      behavior: "smooth"
    });
  });
});


//
document.addEventListener('DOMContentLoaded', function() {
  var humCateKey = document.querySelector('.hum_cate--key');
  var humCateMin = document.querySelector('.hum_cate--min');

  humCateKey.addEventListener('click', function() {
    if (humCateMin.style.maxHeight === '0px' || humCateMin.style.maxHeight === '') {
      // 理想的には、要素の全ての子要素の高さを合計すべきですが、ここでは例として200pxを設定
      humCateMin.style.maxHeight = '300px';
    } else {
      humCateMin.style.maxHeight = '0px';
    }
  });
});
